import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';

export const EmbedBrandStrip = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const navLinks = [
    { name: t('navbar.product'), path: '/product' },
    { name: t('navbar.pricing'), path: '/pricing' },
    { name: t('navbar.docs'), path: '/docs' },
    { name: t('navbar.company'), path: '/company' },
  ];

  return (
    <div className="w-full bg-deep-black/60 backdrop-blur-sm border-b border-glass-border py-3 relative z-40">
      <div className="container mx-auto px-6 flex items-center gap-8">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 group shrink-0">
          <div className="relative w-6 h-6 flex items-center justify-center">
            <div className="absolute inset-0 border border-glass-cyan rotate-45 transition-transform group-hover:rotate-90" />
            <div className="w-1.5 h-1.5 bg-glass-cyan rounded-full shadow-[0_0_8px_#00f0ff]" />
          </div>
          <span className="font-display font-bold text-base tracking-wider text-white">
            INFINITY <span className="text-glass-cyan">BLUE</span>
          </span>
        </Link>

        {/* Nav Tabs */}
        <nav className="flex items-center gap-6 overflow-x-auto scrollbar-hide">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={cn(
                "text-xs font-medium tracking-wide uppercase whitespace-nowrap transition-colors",
                location.pathname === link.path
                  ? "text-glass-cyan"
                  : "text-gray-400 hover:text-glass-cyan"
              )}
            >
              {link.name}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};
